export function validate(object) {
    if (object.name === "" || object.email === "" || object.salary === "" ||
        object.salary_variable === "" || !object.area || !object.industry || !object.country || !object.job || !object.size ||
        !object.qualification) {
        return false
    }
    return true
} 